import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const PARALLAX_LAYER_SELECTOR = '.fz-product-page__photo-inner'
const PARALLAX_RANGE_PERCENT = 4

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function createProductParallaxAnimation(container: HTMLElement | null) {
  if (!container || prefersReducedMotion()) {
    return null
  }

  const layer = container.querySelector<HTMLElement>(PARALLAX_LAYER_SELECTOR)
  if (!layer) {
    return null
  }

  return gsap.context(() => {
    gsap.fromTo(
      layer,
      { yPercent: -PARALLAX_RANGE_PERCENT },
      {
        yPercent: PARALLAX_RANGE_PERCENT,
        ease: 'none',
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      },
    )
  }, container)
}
